class Help {
    //static isMobile() {
    //    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    //}
    static isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }
    ;
    //https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_matchmedia
    //https://css-tricks.com/working-with-javascript-media-queries/
    static matchesMediaQuery(mediaQuery) {
        return window.matchMedia(mediaQuery).matches;
    }
    static isNarrowOrShortIsMobileDevice() {
        let respVal = false;
        if (Help.matchesMediaQuery(Help.narrowMedia)) {
            console.log(`is narrow`);
            respVal = true;
        }
        if (Help.matchesMediaQuery(Help.shortMedia)) {
            console.log(`is short`);
            respVal = true;
        }
        if (Help.isMobileDevice()) {
            console.log(`is mobile device`);
            respVal = true;
        }
        return respVal;
        //return Help.matchesMediaQuery(Help.narrowMedia) || Help.isMobileDevice();
    }
    /**
     * https://stackoverflow.com/questions/1418569/javascript-max-function-for-3-numbers
     * @param array
     */
    static maxOfArray(array) {
        return Math.max.apply(Math, array);
    }
    /**
     * Will merge the properties of two objects
     * Does not handle arrays - see ChartHelp.mergeChartData for merging of arrays by index using assign and map
     * Will happily work with arrays instead of objects - just treats each index like an ojbect key item
     * Will also happily replace an objects property that is an array
     * Only works one level deep - either objects or arrays
     * */
    static mergeObjects(obj1, obj2) {
        return Object.assign(obj1, obj2);
    }
    /**
     * Take an object to work on, a string dot notation path e.g. "user.address.postcode" and returns the value of the object at that "path"
     * If the third param "value" is passed then will set the relevant key to that value
     * //https://stackoverflow.com/questions/6393943/convert-javascript-string-in-dot-notation-into-an-object-reference
     * @param obj - Target object
     * @param stringPath - path on that object
     * @param value - (optional) value to set
     */
    static objReferenceFromString(obj, stringPath, value) {
        if (typeof stringPath == 'string')
            return Help.objReferenceFromString(obj, stringPath.split('.'), value);
        else if (stringPath.length == 1 && value !== undefined)
            return obj[stringPath[0]] = value;
        else if (stringPath.length == 0)
            return obj;
        else
            return Help.objReferenceFromString(obj[stringPath[0]], stringPath.slice(1), value);
    }
    static sqftTosqm(s) {
        let respVal = null;
        if (!Help.isNullOrUndef(s)) {
            respVal = (s / 10.764).toFixed(0);
        }
        return respVal;
    }
    static numberedLabel(l, n) {
        return `${l} <i>${n}</i>`;
    }
    static coloredNumberedLabel(l, n, c) {
        return `<span class="${c}"></span>${l} <i>${n}</i>`;
    }
    static labelledTag(l, s, t, c = "") {
        return Help.isGoodString(s) ? `<span class="label ${c}">${l}</span>${Help.htmlTag(s, t)}` : "";
    }
    static labelledList(l, s) {
        var str = Help.htmlList(s);
        return Help.isGoodString(str) ? `<span class="label">${l}</span>${str}` : "";
    }
    static htmlTag(s, t, as = "") {
        return Help.isGoodString(s) ? `<${t} ${as}>${s}</${t}>` : "";
    }
    static htmlList(s) {
        var respVal = "";
        if (!Help.isNullOrUndef(s) && s.length > 0) {
            respVal = "<ul>";
            s.forEach(v => respVal += `<li>${v}</li>`);
            respVal += "</ul>";
        }
        return respVal;
    }
    static trimEnd(s) {
        return s.slice(0, -1);
    }
    static trimEndCharacters(s, targetString) {
        if (targetString === undefined)
            targetString = "\s";
        return s.replace(new RegExp("[" + targetString + "]+$"), "");
    }
    /**
    * Fairly lame don't expect magic
    */
    static singulariseWord(s) {
        var respVal = s;
        if (!s.endsWith("ss")) {
            Help.trimEndCharacters(s, "s");
        }
        return respVal;
    }
    /**
     * Fairly lame don't expect magic
     */
    static singulariseWords(s) {
        var respVal = s;
        let parts = s.split(" ");
        if (parts.length > 0) {
            respVal = "";
            parts.forEach(p => respVal += `${Help.singulariseWord(p)} `);
        }
        return respVal;
    }
    static removeFullStop(s) {
        return s.replace('.', '');
    }
    static splitStringOnWhitepace(s) {
        let respVal = [];
        if (Help.isGoodString(s)) {
            respVal = s.split(" ");
        }
        return respVal;
    }
    static splitStringOnLinebreaks(s) {
        let respVal = [];
        if (Help.isGoodString(s)) {
            respVal = s.split(/\r?\n/g);
        }
        return respVal;
    }
    //cref:https://gist.github.com/jonlabelle/5375315
    static splitOnCamelCase(str) {
        //str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2');
        //str = str.toLowerCase(); //add space between camelCase text
        return str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2');
    }
    static camelCaseFirstLetter(str) {
        return str.charAt(0).toLowerCase() + str.substring(1);
    }
    static pascalCaseFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }
    static formatEnumText(str) {
        return Help.pascalCaseFirstLetter(Help.splitOnCamelCase(str));
    }
    //static isIn()
    //    internal static bool IsIn<T>(this T value, List<T> list)
    //{
    //    return list.Any(x => x.Equals(value));
    //}
    static isGoodString(s) {
        return !Help.isNullOrEmpty(s) && Help.isString(s);
    }
    static isGoodNumber(s) {
        return !Help.isNullOrUndef(s) && Help.isNumber(s);
    }
    static isNumber(n) {
        return typeof n === "number";
    }
    static canConvertToNumber(s) {
        return !isNaN(+s);
    }
    static isString(n) {
        return typeof n === "string";
    }
    static StringtContains(s, t) {
        return (s.indexOf(t) >= 0);
    }
    static isNullOrUndef(val) {
        return val === undefined || val === null;
    }
    static isNullOrEmpty(val) {
        return Help.isNullOrUndef(val) || val === '' || val === 'null' || val === 'undefined';
    }
    static stringContains(term, source) {
        var respVal = false;
        if (Help.isString(term)) {
            respVal = (source.indexOf(term) !== -1);
        }
        return respVal;
    }
    static getProp(key, obj, defaultVal = null) {
        return Help.hasProp(key, obj) ? obj[key] : defaultVal;
    }
    static tryGetProp(key, obj, result) {
        let respVal = false;
        if (Help.hasProp(key, obj)) {
            result.value = Help.getProp(key, obj);
            respVal = true;
        }
        return respVal;
    }
    static hasProp(key, obj) {
        return (key in obj);
    }
    static getItem(ary, i, defaultVal = null) {
        return !Help.isNullOrUndef(ary) ? ary[i] : defaultVal;
    }
    static hasIndex(arr, i) {
        return (arr[i] != null);
    }
    static contains(arr, item) {
        if (Array.isArray(arr)) {
            return arr.indexOf(item) > -1;
        }
        return false;
    }
    static first(arr) {
        return arr[0];
    }
    static last(arr) {
        return arr[arr.length - 1];
    }
    static sumArray(arr) {
        return arr.reduce(function (a, b) {
            return a + b;
        }, 0);
    }
    static arrayAllEqual(arr) {
        return arr.every(function (val) {
            return val === arr[0];
        });
    }
    static single(arr, selectorFn) {
        var matches = arr.filter(selectorFn);
        if (matches.length === 1) {
            return matches[0];
        }
        else {
            console.log("matches.length not 1 " + matches.length);
            console.log(arr.length);
        }
        throw Error("Help.single : Item not found");
    }
    static singleOrNull(arr, selectorFn) {
        var matches = arr.filter(selectorFn);
        if (matches.length === 1) {
            return matches[0];
        }
        return null;
    }
    static containsAllItems(array1, array2) {
        return !(Help.except(array2, array1).length > 0);
    }
    static except(array1, array2) {
        return array1.filter(x => !array2.includes(x));
    }
    /**
    * creates an entirely new array that is a copy of the original array, except with the target item remove.
    */
    static newArrayWithoutItem(arr, item) {
        return arr.filter(e => e !== item);
    }
    /**
    * mutates array with splice
    */
    static removeItemFromArray(arr, item) {
        let indexToDelete = arr.indexOf(item);
        if (indexToDelete >= 0) {
            arr.splice(indexToDelete, 1);
        }
    }
    static stripQueryStringAndHashFromPath(url) {
        return url.split("?")[0].split("#")[0];
    }
    static hasClass(element, cls) {
        return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    }
    static objectsEqualByValue(obj1, obj2) {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    }
    static deepCloneObject(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    static cloneObject(obj) {
        return Object.assign({}, obj);
    }
    static cloneExceptKey(obj, keyToRemove) {
        let clone = Object.assign({}, obj);
        delete clone[keyToRemove];
        return clone;
    }
    static cloneAndMod(obj, kvpsToOverwrite) {
        const overwritten = Object.assign({}, obj, kvpsToOverwrite);
        return overwritten;
    }
    static isValidDate(val) {
        let respVal = false;
        if (Object.prototype.toString.call(val) === "[object Date]") {
            if (!isNaN(val.getTime())) {
                respVal = true;
            }
        }
        return respVal;
    }
    static numberTryParse(intString, result) {
        result.value = parseInt(intString, 10);
        return !isNaN(result.value);
    }
    static randomScalingFactor() {
        return Math.round(Math.random() * 100);
    }
    ;
}
Help.narrowMediaCss = "screen and (max-width: 600px)";
Help.narrowMedia = "screen and (max-width: 900px)";
Help.shortMedia = "screen and (max-height: 900px)";
export default Help;
